export const orderListElement = {
    orderNumber: "Bestellnummer",
    orderDate: "Bestelldatum",
    orderSum: "Summe",
    shippingCost: "Versandkosten",
    status:  "Status"
}
export const orderList = {
    orderHistory: "BESTELLVERLAUF"
}